import { AttributeTypeFacetModel, VariantTraitModel } from "@insite/client-framework/Types/ApiModels";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { WithCustomProperties } from "@thkStore/Types/CustomPropertiesByParentModel";

export const enum VariantGridFields {
    defaultPageSize = "defaultPageSize",
    pageSizeOptions = "pageSizeOptions",
    customRailHeaderText = "customRailHeaderText",
    customRailImage = "customRailImage",
    customRailUnitLabel = "customRailUnitLabel",
    customRailMountingHolePitchLabel = "customRailMountingHolePitchLabel",
    customRailLengthMinLabel = "customRailLengthMinLabel",
    customRailLengthMaxLabel = "customRailLengthMaxLabel",
    customRailLengthIncrementLabel = "customRailLengthIncrementLabel",
    customRailG1MinLabel = "customRailG1MinLabel",
    customRailG1MaxLabel = "customRailG1MaxLabel",
    customRailG1IncrementLabel = "customRailG1IncrementLabel",
    customRailG2MinLabel = "customRailG2MinLabel",
    customRailG2MaxLabel = "customRailG2MaxLabel",
    customRailG2IncrementLabel = "customRailG2IncrementLabel",
    customRailCancelButtonLabel = "customRailCancelButtonLabel",
    customRailConfirmButtonLabel = "customRailConfirmButtonLabel",
}

export interface VariantGridWidgetFields {
    [VariantGridFields.defaultPageSize]: number;
    [VariantGridFields.pageSizeOptions]: string;
    [VariantGridFields.customRailHeaderText]: string;
    [VariantGridFields.customRailImage]: string;
    [VariantGridFields.customRailUnitLabel]: string;
    [VariantGridFields.customRailMountingHolePitchLabel]: string;
    [VariantGridFields.customRailLengthMinLabel]: string;
    [VariantGridFields.customRailLengthMaxLabel]: string;
    [VariantGridFields.customRailLengthIncrementLabel]: string;
    [VariantGridFields.customRailG1MinLabel]: string;
    [VariantGridFields.customRailG1MaxLabel]: string;
    [VariantGridFields.customRailG1IncrementLabel]: string;
    [VariantGridFields.customRailG2MinLabel]: string;
    [VariantGridFields.customRailG2MaxLabel]: string;
    [VariantGridFields.customRailG2IncrementLabel]: string;
    [VariantGridFields.customRailCancelButtonLabel]: string;
    [VariantGridFields.customRailConfirmButtonLabel]: string;
}

export interface VariantGridOwnProps extends WidgetProps {
    fields: VariantGridWidgetFields;
}

export type FilterState = { [attributeTypeId: string]: Set<string> };

export interface VariantFilters {
    searchWithin?: string[];
    facets?: FilterState;
}

export interface VariantChildrenGridApiParameter {
    productId: string;
    variantChildrenGrid: true;
    page?: number;
    pageSize?: number;
    sort?: string;
    searchWithin?: string;
    attributeValueIds?: string[];
    filterAttributeValueIds?: string[];
    searchText?: string;
}

export type SortType = "BestMatch" | "ProductAToZ" | "ProductZToA";

export type CustomVariantTraitModel = VariantTraitModel & WithCustomProperties;
export type CustomAttributeTypeFacetModel = AttributeTypeFacetModel & WithCustomProperties;

export interface VariantTraitValueFacetModel {
    styleTraitValueId: string;
    value: string;
    count: number;
}

export interface VariantTraitFacetModel {
    styleTraitId: string;
    name: string;
    sortOrder: number;
    traitValueFacets: VariantTraitValueFacetModel[];
}

export interface VariantAttributeValueFacetModel {
    attributeValueId: string;
    value: string;
    count: number;
}

export interface VariantAttributeFacetModel {
    attributeTypeId: string;
    name: string;
    sortOrder: number;
    attributeValueFacets: VariantAttributeValueFacetModel[];
}
